var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9449_141473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.540039 14.11C1.00004 9.44996 3.00004 5.46996 6.55004 2.93996C11.29 -0.430036 16.81 -0.590037 20.22 4.22996C23.51 8.85996 18.65 14.03 20.22 16.17L21.61 18.17L15 22.81L12.9 20C10.58 16.72 14.9 10.84 13.54 8.87996C12.54 7.52996 10.96 8.18996 9.71004 9.07996C8.18004 10.14 7.35004 13 7.15004 15.27L0.540039 14.11ZM19.86 23.11C22.39 21.31 25.34 21.85 26.78 23.88C28.22 25.91 27.78 28.72 25.14 30.56C24.1421 31.3169 22.8896 31.6576 21.6457 31.5103C20.4018 31.3629 19.2635 30.7391 18.47 29.77C17.7747 28.7049 17.5305 27.4073 17.7911 26.1623C18.0517 24.9173 18.7958 23.8267 19.86 23.13V23.11Z",
    stroke: "#FF8000",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9449_141473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.07,
    height: 32.05,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeSmall);
export default __webpack_public_path__ + "static/media/orange-small.91db5b112eb0f24134e11a4aedf4241c.svg";
export { ForwardRef as ReactComponent };